import React from 'react';

type BadgeColor =
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'gray'
  | 'dark'
  | 'secondary'
  | 'light';

interface InfoFieldProps {
  label: string;
  value?: string | number | null;
  className?: string;
  badgeColor?: BadgeColor;
}

const badgeColorMap: Record<BadgeColor, string> = {
  primary: 'bg-primary text-white',

  secondary: 'bg-[#13C296] text-white',

  dark: 'bg-[#212B36] text-white',

  gray: 'bg-[#637381] text-white',

  light: 'bg-[#EFEFEF] text-[#212B36]',

  warning: 'bg-[#F9C107] text-[#212B36]',

  danger: 'bg-[#DC3545] text-white',

  success: 'bg-[#3CA745] text-white',

  info: 'bg-[#3BA2B8] text-white',
};

const InfoField: React.FC<InfoFieldProps> = ({
  label,
  value,
  className = '',
  badgeColor,
}) => {
  const displayValue =
    value !== null &&
    value !== undefined &&
    String(value).trim() !== ''
      ? String(value)
      : 'N/A';

  return (
    <div className={className}>
      <label className="mb-1 block text-sm font-semibold text-black dark:text-white">
        {label}:
      </label>

      {badgeColor ? (
        <span
          className={`inline-flex rounded-md px-3 py-1 text-sm font-medium ${
            badgeColorMap[badgeColor]
          }`}
        >
          {displayValue}
        </span>
      ) : (
        <p className="text-sm text-bodydark2 dark:text-bodydark">
          {displayValue}
        </p>
      )}
    </div>
  );
};

export default InfoField;